module.exports = ".divInfo{\r\n    padding: 20px;\r\n    background-color: #eee;\r\n    border-radius: 5px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.btn-info:hover{\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment.component.css
// module id = ./src/app/payment/payment.component.css
// module chunks = main